// Shared between StepStatusAutomation.jsx and StepChannels.jsx -- both reference the same
// backend ChannelType enum (CyberJob.Domain.Interactions.ChannelType) for their channel selects,
// so the option list/values live in one place instead of two copies drifting apart.

export const CHANNEL_OPTIONS = [
    { value: "WhatsApp", label: "WhatsApp" },
    { value: "Sms", label: "SMS" },
    { value: "Email", label: "E-mail" },
];

export const CHANNEL_SEQUENCE_MODE_OPTIONS = [
    { value: "Sequential", label: "Sekwencyjnie" },
    { value: "Parallel", label: "Równolegle" },
];
